
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiClipboard2 as ObiClipboard2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-clipboard-2.js';
 
 
 

 
 export const ObiClipboard2 = createComponent({
   react: React,
   tagName: 'obi-clipboard-2',
   elementClass: ObiClipboard2Element,
   events: {
     
   }
  });
 
 